import { ConfigService } from '@maia/config';
import { BaseService } from '@maia/feature-utils';
import { HttpService } from '@maia/httpClient';
import { PutQuestionDto } from '@maia/shared';
import { ICancellationQuestion } from '../../entitites/cart.entity';

export class CancellationService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async createCancellation({
    customerGuid,
    insuranceGuid,
  }: {
    customerGuid: string;
    insuranceGuid: string;
  }) {
    return await this.post<{ cancellation_guid: string }, {}>(
      `customers/${customerGuid}/insurances/${insuranceGuid}/cancellations`,
      {},
      'create cancellations',
    );
  }

  public async getCancellationQuestions({
    customerGuid,
    insuranceGuid,
    cancellationGuid,
  }: {
    customerGuid: string;
    insuranceGuid: string;
    cancellationGuid: string;
  }) {
    return await this.get<ICancellationQuestion>(
      `customers/${customerGuid}/insurances/${insuranceGuid}/cancellations/${cancellationGuid}`,
      'get cancellation questions',
    );
  }

  public async putCancellationQuestions({
    customerGuid,
    cancellationGuid,
    questions,
  }: {
    customerGuid: string;
    cancellationGuid: string;
    questions: ConstructorParameters<typeof PutQuestionDto>[number];
  }) {
    return await this.put<unknown, PutQuestionDto['questions']>(
      `customers/${customerGuid}/cancellations/${cancellationGuid}/questions`,
      {
        questions,
      },
      'Answer cancellation questions',
    );
  }

  public async submitCancellation({
    customerGuid,
    cancellationGuid,
  }: {
    customerGuid: string;
    cancellationGuid: string;
  }) {
    return await this.post<unknown, {}>(
      `customers/${customerGuid}/cancellations/${cancellationGuid}/finalize`,
      {},
      'Submit',
    );
  }
}
